import { useEffect } from "react";
import { LandingPageProps } from "./types";

const PreloadImages = (pageProps: LandingPageProps) => {
  useEffect(() => {
    // Extract image URLs to avoid complex expressions in dependency array
    const claimSettlementIcon = pageProps?.data?.claimSettlementText?.icon;
    const travelSearchBannerIcon = pageProps?.data?.travelSearchBanner?.icon;
    const secureTravData = pageProps?.data?.secureTravData;
    const secureTravImg0 = secureTravData?.[0]?.travImg;
    const secureTravImg1 = secureTravData?.[1]?.travImg;

    // Collect all image URLs
    const imageUrls: string[] = [];

    if (claimSettlementIcon) {
      imageUrls.push(claimSettlementIcon);
    }
    if (travelSearchBannerIcon) {
      imageUrls.push(travelSearchBannerIcon);
    }
    if (secureTravImg0) {
      imageUrls.push(secureTravImg0);
    }
    if (secureTravImg1) {
      imageUrls.push(secureTravImg1);
    }

    // Static image URLs
    const staticImages = [
      "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_27565_cc0104059a.png",
      "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg",
      "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
      "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg",
      "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_2e09571187.svg",
      "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_db78b6056e.svg",
    ];

    imageUrls.push(...staticImages);

    // Function to prefetch images
    const prefetchImages = () => {
      imageUrls.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    };

    // Wait for page to be stable (load event + idle callback)
    const loadImagesWhenStable = () => {
      if (window.requestIdleCallback) {
        // Use requestIdleCallback if available (modern browsers)
        window.requestIdleCallback(prefetchImages, { timeout: 2000 });
      } else {
        // Fallback: wait a bit after load event
        setTimeout(prefetchImages, 1000);
      }
    };

    // Check if page is already loaded
    if (document.readyState === "complete") {
      loadImagesWhenStable();
    } else {
      // Wait for page load event
      window.addEventListener("load", loadImagesWhenStable, { once: true });
    }

    // Cleanup
    return () => {
      window.removeEventListener("load", loadImagesWhenStable);
    };
  }, [
    pageProps?.data?.claimSettlementText?.icon,
    pageProps?.data?.travelSearchBanner?.icon,
    pageProps?.data?.secureTravData,
  ]);

  // Return null since we're not rendering anything
  return null;
};

export default PreloadImages;
